export { default as RewardsList } from './Rewards';
